import { ChangeEvent, useRef } from 'react';
import { styled } from '@mui/material';
import { handleKey, variables } from '..';

export function FileInput({
  title,
  onChange,
  filename,
}: {
  title: string;
  onChange: (a: ChangeEvent<HTMLInputElement>) => void;
  filename: string;
}) {
  const inputEl = useRef(null);
  return (
    <Wrapper
      onKeyUp={handleKey(() => (inputEl.current! as HTMLInputElement).click())}>
      <Action tabIndex={0}>
        {title}
        <input
          onChange={onChange}
          ref={inputEl}
          style={{ display: 'none' }}
          type="file"
        />
      </Action>
      <label>{filename}</label>
    </Wrapper>
  );
}

const Wrapper = styled('article')(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',

  '&>*+*': { marginLeft: '0.5em' },
}));

const Action = styled('label')(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: variables.cardBorderRadius,
  padding: '1rem',
  color: 'rgba(0, 0, 0, 0.87)',
  boxShadow:
    '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  backgroundColor: '#e0e0e0',

  fontWeight: 500,
  textTransform: 'uppercase',
}));
